<template>
  <div v-if="activeAnnouncement?.active" class="active-announcement">
    <LcMessageBox
      :key="uniqueId('announcement')"
      :headline="activeAnnouncement.title"
      :model-value="!isCollapsed"
      variant="warning"
      @update:model-value="handleUpdate(!$event)"
    >
      <!-- DO NOT CHANGE! PREVENTS WHITE SPACES -->
      <pre class="description">{{ activeAnnouncement.description }}</pre>
    </LcMessageBox>
  </div>
</template>

<script setup lang="ts">
const {
  activeAnnouncement,
  isCollapsed,
  licensedTerritory,
  setAnnouncementByKey,
} = useActiveAnnouncement()

const handleUpdate = (collapsed: boolean) => {
  if (!activeAnnouncement.value) return

  setAnnouncementByKey(licensedTerritory, {
    ...activeAnnouncement.value,
    collapsed,
  })
}
</script>

<style lang="scss" scoped>
.active-announcement {
  .description {
    @include token-paragraph-regular;

    overflow-x: auto;
    margin: 0;
    white-space: pre-wrap;
    overflow-wrap: break-word;
  }
}
</style>
